import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { CertificadosFsViewModel } from '../buscador-certificadosfs.types';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-certificadosfs-edit',
    templateUrl: './buscador-certificadosfs-edit.component.html',
    styleUrls: ['./buscador-certificadosfs-edit.component.scss'],
})
export class CertificadosFsEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() certFs: CertificadosFsViewModel;
    @Input() formGroup: FormGroup;
    editTitle = 'Editar';
    isCollapsedCabecera = false;
    form: FormGroup<any>;
    CodigoSolicitud: string;
    // IdSolicitud: number;
    NumeroCertificado: string;
    EstadoCfDescripcion: string;
    EstadoSolicitudExDescripcion: string;
    CfUtilizado: boolean;
    CfDisponible: boolean;
    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.CodigoSolicitud = this.certFs.CodigoSolicitud;
        this.NumeroCertificado = this.certFs.NumeroCertificado;
        this.EstadoCfDescripcion = this.certFs.EstadoCfDescripcion;
        this.EstadoSolicitudExDescripcion = this.certFs.EstadoSolicitudExDescripcion;
        this.CfDisponible = this.certFs.CfDisponible;
        this.CfUtilizado = this.certFs.CfUtilizado;
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.certFs?.currentValue) {
            this.certFs = { ...changes.certFs?.currentValue };
            this.updateForm();
        }
    }

    private updateForm(): void {
        this.formGroup.setValue({
            CodigoSolicitud: this.certFs?.CodigoSolicitud,
            NumeroCertificado: this.certFs?.NumeroCertificado,
            EstadoSolicitudExDescripcion: this.certFs?.EstadoSolicitudExDescripcion,
            EstadoCfDescripcion: this.certFs?.EstadoCfDescripcion,
            CfUtilizado: this.certFs?.CfUtilizado || false,
            CfDisponible: this.certFs?.CfDisponible || false,
        });

        this.form = this.formGroup;
    }
}
